import data from '../../../../shared/standards/iso42001.json';
export default data;
